
export const LOAD_VISIT = 'LOAD_VISIT';
export const CHANGE_VISIT = 'CHANGE_VISIT';

export const CREATE_VISIT_REQUEST = 'CREATE_VISIT_REQUEST';
export const CREATE_VISIT_SUCCESS = 'CREATE_VISIT_SUCCESS';
export const CREATE_VISIT_ERROR = 'CREATE_VISIT_ERROR';

export const UPDATE_VISIT_REQUEST = "UPDATE_VISIT_REQUEST";
export const UPDATE_VISIT_SUCCESS = "UPDATE_VISIT_SUCCESS";
export const UPDATE_VISIT_ERROR = "UPDATE_VISIT_ERROR";

export const MARK_FILE_FOR_REMOVAL = 'MARK_FILE_FOR_REMOVAL';

export const COPY_VISIT_REQUEST = "COPY_VISIT_REQUEST";
export const COPY_VISIT_SUCCESS = "COPY_VISIT_SUCCESS";
export const COPY_VISIT_ERROR = "COPY_VISIT_ERROR";



export const createVisit = (site, visit) => {
    return {
        type: 'CALL_API',
        types: [CREATE_VISIT_REQUEST, CREATE_VISIT_SUCCESS, CREATE_VISIT_ERROR],
        path: `api/siteinspection/${site.id}/visit`,
        method: 'post',
        payload: visit,
        redirect: () => {
             return `/inspection/${site.id}`;
        }
    };
};

export const updateVisit = (site, visit) => {
    return {
        type: 'CALL_API',
        types: [UPDATE_VISIT_REQUEST, UPDATE_VISIT_SUCCESS, UPDATE_VISIT_ERROR],
        path: `api/siteinspection/${site.id}/visit/${visit.id}`,
        method: 'put',
        payload: visit,
        redirect: () => {
            return `/inspection/${site.id}`;
        }
    };
};

export const copyVisit = (inspectionId, visitId, addressId, government_land) => {
    return {
        type: 'CALL_API',
        types: [COPY_VISIT_REQUEST, COPY_VISIT_SUCCESS, COPY_VISIT_ERROR],
        path: `api/visit/copy`,
        method: 'post',
        payload: {
            source_site_inspection_id: inspectionId,
            source_visit_id: visitId,
            target_address_id: addressId,
            government_land: government_land
        },
        redirect: (response) => {
            return `/inspection/${response.inspection.id}`;
        }
    };
};



export const loadVisit = (visit) => {
    return { type: LOAD_VISIT, payload: {visit} };
};

export const changeVisit = (visit) => {
    return { type: CHANGE_VISIT, payload: {visit} };
};

export const markFileForRemoval = (id) => {
    return {type: MARK_FILE_FOR_REMOVAL, payload: {id}}
};


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/visit.js